import React from 'react';
import WebsiteNavbar from '../components/website/WebsiteNavbar';
import WebsiteFooter from '../components/website/WebsiteFooter';

const PrivacyPolicyPage: React.FC = () => {
  const sections = [
    {
      title: 'Information We Collect',
      content: 'When you use CricClash, we collect information that helps provide, maintain, and improve our services. This includes personal details like your name, email address, and phone number when you register. We also collect usage data including your device information, IP address, browser type, and operating system for security and analytics purposes.'
    },
    {
      title: 'How We Use Your Data',
      content: 'We use your information to operate and improve CricClash. This includes providing fantasy cricket services, processing transactions, personalizing your experience, communicating about contests and promotions, ensuring platform security, and analyzing usage patterns to enhance our features. Your data helps us deliver a better gaming experience.'
    },
    {
      title: 'Data Security',
      content: 'We implement industry-standard measures to protect your information. This includes encryption of data in transit and at rest, secure server infrastructure, regular security audits, and strict access controls. While no method of transmission over the Internet is 100% secure, we strive to use commercially acceptable means to protect your personal data.'
    },
    {
      title: 'Information Sharing',
      content: 'We do not sell your personal information to third parties. We may share data with trusted service providers who assist in platform operations, such as payment processors, analytics providers, and cloud hosting services. We may also disclose information when required by law or to protect our users\' safety and platform integrity.'
    },
    {
      title: 'Your Rights',
      content: 'You have the right to access, update, or delete your personal information at any time. You can manage your privacy preferences, opt out of marketing communications, and request a copy of your data. To exercise any of these rights, please contact our support team or visit your account settings.'
    },
    {
      title: 'Contact Us',
      content: 'If you have any questions about this Privacy Policy or our data practices, please contact us at privacy@cricclash.com. You can also reach our support team through the Help Center in the app, or by contacting our support portal.'
    },
  ];

  return (
    <div className="min-h-screen bg-[#0F1114]">
      <WebsiteNavbar />

      <div className="pt-24 pb-20 px-4">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <div className="inline-block px-3 py-1 bg-[#13EC5B]/10 border border-[#13EC5B]/20 rounded-full text-[#13EC5B] text-xs font-semibold mb-4 uppercase tracking-wider">
              Legal Information
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">Privacy Policy</h1>
            <p className="text-gray-500">Last updated: October 15, 2025</p>
            <p className="text-gray-400 mt-4 leading-relaxed">
              At CricClash, we value your privacy. This policy explains how we collect, use, and protect your personal information when you enjoy our fantasy cricket platform. We are committed to ensuring the privacy of your data.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((section, i) => (
              <div key={i} className="group">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-[#13EC5B]/10 border border-[#13EC5B]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-[#13EC5B] font-bold text-sm">{i + 1}</span>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white mb-3">{section.title}</h2>
                    <p className="text-gray-400 leading-relaxed">{section.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <WebsiteFooter />
    </div>
  );
};

export default PrivacyPolicyPage;
